var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"voice-class-create-form"},[_c('voice-class-base-form',{on:{"submit":_vm.saveVoiceClass}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }